var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwakenImg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.344238,
    y: 0.344116,
    width: 99,
    height: 99,
    rx: 20,
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwakenImg9);
export default __webpack_public_path__ + "static/media/awaken-img-9.d4e25f11ffbecf9bd7d6d6cf5f5b44fb.svg";
export { ForwardRef as ReactComponent };